import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { Row } from 'write-excel-file';

import type { WidgetExportOptions } from 'src/components/dashboard/DashboardPage/components/WidgetFrame/useWidgetExport';

import type { RootCauseData } from './mapper';

type UseExportOptionsProps = {
  data: RootCauseData | null;
} & Pick<WidgetExportOptions, 'widgetName' | 'queryFilters'>;

export const useRootCauseExportOptions = ({
  data,
  widgetName,
  queryFilters,
}: UseExportOptionsProps): WidgetExportOptions => {
  const { t } = useTranslation('followUp');

  return useMemo(() => {
    const rows: Row[] = (data?.bars || []).map((bar) => [
      {
        value: bar.label,
      },
      {
        value: bar.count,
      },
    ]);

    if (data) {
      rows.push([
        {
          value: t('statistics.rootCausesWidget.totalFollowUps', {
            defaultValue: 'Total Follow-Ups:',
          }),
        },
        { value: data.total },
      ]);
    }

    return {
      widgetName,
      rows,
      queryFilters,
    };
  }, [data, queryFilters, t, widgetName]);
};
